var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"label text-white m-r-xs none-radius inline prod-label",class:_vm.statusClass},[_vm._v(" "+_vm._s(_vm.code)+" "),(_vm.qty)?_c('span',{staticClass:"text-xs text-muted"},[_vm._v("("+_vm._s(_vm.qty)+")")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }